<template>
  <div class="utilizationReportSearch">
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
      <Row :gutter="4">
        <!-- 选择公司 -->
        <div v-if="company == 1">
          <Col span="5">
            <FormItem label="" prop="companyIds">
              <Select
                v-model="formValidate.companyIds"
                filterable
                :placeholder="$t('RAM.common.PleaseSelectCompany')"
                :transfer="true"
                @on-change="companyIdChange"
                multiple
              >
                <Option
                  :value="item.id"
                  v-for="item in companyIdList"
                  :key="item.id"
                  >{{ item.companyName }}</Option
                >
              </Select>
            </FormItem>
          </Col>
        </div>
        <Col span="4">
          <FormItem label="" prop="accountIds">
            <Select
              v-model="formValidate.accountIds"
              filterable
              multiple
              :max-tag-count="1"
              :placeholder="$t('alarms.common.pleaseSelectAccount')"
              :transfer="true"
              @on-change="changeAccountId(accountIds)"
            >
              <Option
                :value="item.id"
                v-for="item in accountList"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="4" style="width: 218px">
          <FormItem label="" prop="statisticsDate">
            <DatePicker
              type="date"
              :placeholder="$t('instance_list.selectByDate')"
              value-format="yyyy-MM-dd"
              v-model="formValidate.statisticsDate"
              :options="dateOptions"
              @on-change="changeTimeType"
              style="width: 100%"
            ></DatePicker>
          </FormItem>
        </Col>
        <Col span="3">
          <FormItem label="" prop="interval">
            <Input
              search
              v-model="formValidate.interval"
              type="number"
              :placeholder="$t('Bill.ResourceOptimization.queryInterval')"
              @on-search="searchInterval()"
            />
          </FormItem>
        </Col>
      </Row>
    </Form>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil";
import TableUtilizationReport from "../utilization_report/TableUtilizationReport";
var tableUtilizationReport = TableUtilizationReport;
export default {
  name: "UtilizationReportSearch",
  data() {
    return {
      dateOptions: {
        disabledDate (date) {
          return date && date.valueOf() >= Date.now() - (2 * 24 * 60 * 60 * 1000);
        }
      },
      saleDate: "",
      company: getCookie(global.companyId),
      companyIds: [],
      companyIdList: [],
      accountIds: [],
      accountList: [],
      timeType: "",
      statisticsDate: "",
      interval: "",
      formValidate: {
        companyIds: [],
        accountIds: [],
        statisticsDate: "",
        interval: "7",
      },
      ruleValidate: {
        companyIds: [
          {
            required: true,
            message: "请选择公司",
            trigger: "change",
            type: "array",
          },
        ],
        accountIds: [
          {
            required: true,
            message: "请选择账号",
            trigger: "change",
            type: "array",
          },
        ],
        statisticsDate: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
            type: "date",
          },
        ],
        interval: [
          {
            required: true,
            message: "请填写区间",
            trigger: "blur",
            type: "string",
          },
          {
            pattern: /^(\d|[1-8]\d|90)(\.\d+)?$/,
            message: "请填写合适的区间",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted: function () {
    if (this.company == 1) {
      this.listRegisterInformation();
    } else {
      tableUtilizationReport.methods.showAll();
    }
    this.getDates();
  },
  methods: {
    getDates() {
      const aData = new Date(new Date().getTime() - (2 * 24 * 60 * 60 * 1000));
      this.formValidate.statisticsDate =
        aData.getFullYear() +
        "-" +
        (aData.getMonth() + 1) +
        "-" +
        (aData.getDate());
    },
    //查询公司
    listRegisterInformation: function () {
      this.$api.user.listRegisterInformation().then((res) => {
        // 获取公司列表数据
        this.companyIdList = res.data.companies;
        if (this.companyIdList) {
          this.formValidate.companyIds = this.companyIdList[0].id;
        }
      });
    },
    // 切换公司
    companyIdChange: function () {
      this.formValidate.accountIds = [];
      this.searchCompany();
      this.listAccountsByCompanyIdsAndCloudPlatformType();
    },
    // 按公司搜索
    searchCompany: function () {
      eventBus.$emit("companyIds", this.formValidate.companyIds);
      tableUtilizationReport.methods.showAll();
    },
    // 按区间搜索
    searchInterval: function () {
      eventBus.$emit("interval", this.formValidate.interval);
      if (this.formValidate.interval > 90 || this.formValidate.interval < 0) {
        return false;
      } else {
        tableUtilizationReport.methods.showAll();
      }
    },
    /**************************账号**************************/
    listAccountsByCompanyIdsAndCloudPlatformType: function () {
      this.$api.account
        .listAccountsByCompanyIdsAndCloudPlatformType({
          companyIds: this.formValidate.companyIds,
          type: 0,
        })
        .then((res) => {
          this.accountList = res.data;
        });
    },
    // 切换账号
    changeAccountId: function (val) {
      eventBus.$emit("accountIds", this.formValidate.accountIds);
      tableUtilizationReport.methods.showAll();
    },
    /*  日期 */
    changeTimeType: function (e) {
      eventBus.$emit("statisticsDate", e);
      tableUtilizationReport.methods.showAll();
    },
  },
};
</script>
<style scoped>
.utilizationReportSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/ebilling/reserved_instance/utilization_report/UtilizationReportSearch.vue